// What we check before bothering the server.
//
// A short list on purpose. This is a courtesy so somebody who mistyped their
// address finds out without a round trip -- it is NOT the rule. The server
// checks all of this again and its answer is the one that counts, which is why
// there is no phone-number parsing here at all: Sms::PhoneNumber is the one
// parser, and a second opinion on the client is how the two come to disagree.

// Deliberately loose: something before an @, something after, a dot in it. The
// server holds the real pattern (Audiences::Signup::ONLY_EMAIL). Anything
// stricter here would reject addresses the server would have accepted, which is
// the worst possible way to be wrong.
const LOOKS_LIKE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validate(config, values) {
  if (config.collects.email && !LOOKS_LIKE_EMAIL.test((values.email || "").trim())) {
    return { field: "email", message: config.errors.email }
  }

  if (!config.collects.phone) return null

  // The box is required whenever a number was typed, and on a text-only form
  // whenever anything was. Mirrors Signups::Submit#needs_consent?.
  const typed = (values.phone || "").trim().length > 0
  const needed = typed || !config.collects.email

  if (needed && !values.consent) {
    return { field: "consent", message: config.errors.consent }
  }

  return null
}
